import { createSelector } from "reselect";
import { failedMessages } from "utils/selectors";
import { initialState } from "./reducer";

/**
 * Direct selector to the userEditPage state domain
 */

const selectUserEditPageDomain = state =>
  state.get("userEditPage", initialState);

/**
 * Other specific selectors
 */
export const makeSelectLanguages = () =>
  createSelector(selectUserEditPageDomain, substate =>
    substate.get("languages").toJS(),
  );

const makeSelectUser = () =>
  createSelector(selectUserEditPageDomain, substate => {
    const user = substate.get("user");
    return user || null;
  });

const makeSelectPasswordFailed = () =>
  createSelector(selectUserEditPageDomain, substate =>
    failedMessages(substate, "passwordFailed"),
  );

export const makeSelectUserFailed = () =>
  createSelector(selectUserEditPageDomain, substate =>
    failedMessages(substate, "userFailed"),
  );

export const makeSelectUserInProgress = () =>
  createSelector(selectUserEditPageDomain, substate =>
    substate.get("userInProgress"),
  );

export const makeSelectPasswordInProgress = () =>
  createSelector(selectUserEditPageDomain, substate =>
    substate.get("passwordInProgress"),
  );

export const makeSelectPracticeMessages = () =>
  createSelector(selectUserEditPageDomain, substate =>
    substate.get("messages"),
  );

/**
 * Default selector used by UserEditPage
 */

const makeSelectUserEditPage = () =>
  createSelector(selectUserEditPageDomain, substate => substate.toJS());

export default makeSelectUserEditPage;
export { selectUserEditPageDomain, makeSelectUser, makeSelectPasswordFailed };
